var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-preview"},[_c('PDFDocument',{staticClass:"pdf-document",attrs:{"url":_vm.url,"pdf_data":_vm.pdf_data,"currentPage":_vm.currentPage,"numPages":_vm.numPages,"scale":_vm.scale,"inputPage":_vm.inputPage,"iluminateCurrent":"","numberPage":""},on:{"goToPage":_vm.goToPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }